import { TextField, AutocompleteList } from "../../components";
import TelephoneField from "../../components/telephoneField";

interface FieldProps {
  type: string;
  label: string;
  value: string;
  errorMsg: string;
  setFullWidth: boolean;
  id: string;
  pattern: string;
  placeholder: string;
  isRequired: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, type?: string) => void;
  options?: Array<{ value: string; label: string }>;
  customClass?: string;
  selectedCountry?: { value: string; label: string };
  changeCountry?: (countryCode: string) => void;
  maxLength?: number;
  minLength?: number;
}

const Field = (props: FieldProps) => {
  if (props.type === "autocomplete" && props.options)
    return (
      <AutocompleteList
        options={props.options || []}
        label={props.label}
        id={props.id}
        value={props.value}
        onChange={(e) => props.onChange(e, "admin")}
        isRequired={props.isRequired}
        errorMsg={props.errorMsg}
      />
    );
  else if (props.type === "tel")
    return (
      <TelephoneField
        countries={props.options || []}
        selectedCountry={props.selectedCountry || { value: "", label: "" }}
        label={props.label}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        changeCountry={(country) =>
          props.changeCountry ? props.changeCountry(country) : null
        }
        isRequired={props.isRequired}
        errorMsg={props.errorMsg}
        placeholder={props.placeholder}
        pattern={props.pattern}
      />
    );
  else
    return (
      <TextField
        pattern={props.pattern}
        type={props.type}
        label={props.label}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        isRequired={props.isRequired}
        customClass={props.customClass}
        errorMsg={props.errorMsg}
        maxLength={props?.maxLength}
        minLength={props?.minLength}
      />
    );
};

export default Field;
